import { MortgageCalculationService } from '@hb/services/mortgage-calculation/mortgage-calculation.service';
import { StoreService } from '@hb/services/store/store.service';

import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApSpinnerComponent } from '@ap/spinner';
import { ApAmountDisplayComponent } from '@ap/amounts';

@Component({
    selector: 'asset-deficiency',
    templateUrl: './asset-deficiency.component.html',
    styleUrls: ['./asset-deficiency.component.scss'],
    standalone: true,
    imports: [CommonModule, ApContentModule, ApErrorModule, ApSpinnerComponent, ApAmountDisplayComponent]
})
export class AssetDeficiencyComponent {
    protected readonly mortgageCalculationService = inject(MortgageCalculationService);
    protected readonly storeService = inject(StoreService);

    protected readonly math = Math;

    @Input() assetDeficiency: number;
}
